import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './index.css';
import ErrorBoundary from './components/common/ErrorBoundary';

ReactDOM.createRoot(document.getElementById('root')).render(
 <React.StrictMode>
 <ErrorBoundary>
 <Router>
 <App />
 </Router>
 </ErrorBoundary>
 </React.StrictMode>
);
